import { createContext } from 'react';
export const GitHubAuthContext = createContext(null);
